BaseModel = require './base_model.coffee'

class global.Flow extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    emails_per_day: { type: Number }
    status: { default: 'paused' }
    delay_before_finishing_contact_amount: { default: 1 }
    delay_before_finishing_contact_unit: { default: 'days' }
    weekdays_to_send: { type: Array }
    duration_in_days: { type: Number }
    created_at: { type: Date }
    next_valid_statuses: { type: Object }
    recipients_statistics: { type: Object }
    human_weekdays_to_send: { type: Array }
    human_status: {}
    job_status: { type: Object }
    actions_count: { default: 0 }
    bcc: { default: false }
    semi_automatic: { default: true }
    with_task_timer: { default: false }
    interrupted_contacts: { default: false }
    user_id: {}
    lost_reason_id: {}
    set_lost_on_finish: { default: true }
    value: {} # generic attribute
    triggers: { type: Array }
    can_edit_flow_actions: { default: false }
    category_id: { default: null }
  }

  @SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'emails_per_day', 'status', 'weekdays_to_send',
                              'delay_before_finishing_contact_amount', 'delay_before_finishing_contact_unit',
                              'bcc', 'contact_ids_to_be_removed', 'semi_automatic', 'lost_reason_id', 'set_lost_on_finish', 'category_id', 'with_task_timer']

  @ASSOCIATIONS = {
    contacts: -> Contact
    actions: -> FlowAction
    email_statistic: -> EmailStatistic
    user: -> User
  }

  @SERIALIZABLE_ASSOCIATIONS = ['actions']

  recipients_statistics_conversion: ->
    return '--' unless @recipients_statistics?.by_stage
    percentage = (@recipients_statistics.by_stage.conversion.value * 100.0).toFixed(1)
    percentage.replace('.', ',') + '%'

  contacts_count: ->
    return 0 unless @recipients_statistics?.total
    @recipients_statistics.total.count

  isPublished: ->
    @status == 'published'

  isPaused: ->
    @status == 'paused'

  isProcessing: ->
    @job_status != null && (@job_status.status == 'processing' || @job_status.status == 'unitialized')

  errors: ->
    @job_status.errors

  isWithError: ->
    @job_status != null && @job_status.status == 'error'

  hasStatusMessage: ->
    @isProcessing() || @isWithError()

  toggleStatus: ->
    if @isPublished()
      @status = 'paused'
    else
      @status = 'published'
  
  toggleTaskTimer: ->
    @with_task_timer = !@with_task_timer

  toggleType: ->
    @semi_automatic = !@semi_automatic
    @toggleActionTypes()

  toggleActionTypes: ->
    for action in @actions
      continue unless action.type == 'EmailFlowAction' || action.manual_task_parameters.service == Task.emailTaskService.service
      if @semi_automatic
        action.type = 'TaskFlowAction'
        action.manual_task_parameters = { service: Task.emailTaskService.service }
      else
        action.type = 'EmailFlowAction'

  serialize: ->
    serialized = super

    recipients_attributes = []

    for contact in @contacts
      if contact.isPersisted()
        recipients_attributes.push { contact_id: contact.id, priority: contact.recipient_priority }
      else
        recipients_attributes.push { contact_attributes: contact.serialize(), priority: contact.recipient_priority }

    serialized.recipients_attributes = recipients_attributes
    serialized.triggers_attributes = @triggers
    serialized

  canEditActions: ->
    @contacts_count() == 0 || !@id || @can_edit_flow_actions


// WEBPACK FOOTER //
// ./src/models/flow.coffee